import React, { createContext, useContext, useEffect, useState } from "react";
import { me as fetchMe } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("lm_token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    fetchMe()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem("lm_token");
        setToken(null);
      })
      .finally(() => setLoading(false));
  }, [token]);

  const signIn = (t, userObj) => {
    localStorage.setItem("lm_token", t);
    setToken(t);
    setUser(userObj);
  };

  const signOut = () => {
    localStorage.removeItem("lm_token");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
